import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper'

export const calculatorApi = createApi({
  reducerPath: 'calculatorApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/calculator` }),
  tagTypes: [],
  endpoints: (build) => ({
    fetchAllData: build.query({
      query: () => ({
        url: '/'
      })
    }),
    getRates: build.mutation({
      query: (data) => ({
        url: '/fedex_rates',
        method: 'POST',
        body: data
      })
    }),
    getUpsRates: build.mutation({
      query: (data) => ({
        url: '/ups_rates',
        method: 'POST',
        body: data
      })
    }),
    addNewCountries: build.mutation({
      query: (formData) => {
        return {
          url: '/countriesCheapExp',
          method: 'POST',
          body: formData
        }
      },
      // async onQueryStarted({ id, formData, dbData }, { dispatch, queryFulfilled }) {
      //   const { data } = await queryFulfilled;
      //   let patchResult = '';
      //   if (data) {
      //     patchResult = dispatch(
      //       ordersApi.util.updateQueryData('fetchPaymentRequests', id, (draft) => {
      //         const formattedRow = { ...dbData, _id: data._id, createdAt: data.createdAt, clientReferenceId: data.clientReferenceId, paymentRequestId: data.paymentRequestId, paymentLink: data.paymentLink, manager: data.manager };
      //         draft.requests.push(formattedRow);
      //       })
      //     );
      //   }
      //   try {
      //     await queryFulfilled;
      //   } catch {
      //     patchResult.undo(); // Revert optimistic deletion on failure
      //   }
      // }
    })
  })
});